// Lightweight synthesized sounds via WebAudio.
// No external assets required. Fails gracefully if audio is blocked.

let ctx = null;

const getCtx = () => {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    try {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return null;
      ctx = new AC();
    } catch {
      return null;
    }
  }
  return ctx;
};

const beep = ({ freq = 880, duration = 0.05, type = "square", gain = 0.04, when = 0 }) => {
  const c = getCtx();
  if (!c) return;
  if (c.state === "suspended") {
    c.resume().catch(() => {});
  }
  const t0 = c.currentTime + when;
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  g.gain.setValueAtTime(0, t0);
  g.gain.linearRampToValueAtTime(gain, t0 + 0.005);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + duration);
  osc.connect(g);
  g.connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + duration + 0.02);
};

export const playTick = () => {
  beep({ freq: 1200, duration: 0.03, type: "square", gain: 0.025 });
};

export const playRollSequence = () => {
  // rapid ticks (slot-machine feel)
  for (let i = 0; i < 8; i++) {
    beep({ freq: 900 + i * 60, duration: 0.035, type: "square", gain: 0.02, when: i * 0.07 });
  }
};

export const playReveal = () => {
  // low-high confirmation
  beep({ freq: 220, duration: 0.08, type: "sawtooth", gain: 0.05, when: 0 });
  beep({ freq: 660, duration: 0.14, type: "triangle", gain: 0.06, when: 0.08 });
  beep({ freq: 1320, duration: 0.18, type: "sine", gain: 0.05, when: 0.16 });
};
